export default __webpack_public_path__ + "static/media/banner-10.45770311.jpg";